import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import VisitScheduleActions from '../../../../reducers/modules/sales/visit-schedule/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'sales/visit-schedule'

export default class VisitScheduleMiddelware {
  static getToken(){
    return cookieManager.getUserToken();
  }
  static beforeSaveUpdate(id,post,search){
    return (dispatch) => {
      dispatch(VisitScheduleActions.beforeUpdate());
      VisitScheduleMiddelware.saveUpdate(dispatch, id,post,search);
    };
  }
  static beforeSaveChange(post,search){
    return (dispatch) => {
      dispatch(VisitScheduleActions.beforeChange());
      VisitScheduleMiddelware.saveChange(dispatch, post,search);
    };
  }

  static update(params){
    return (dispatch) => {
      dispatch(VisitScheduleActions.update());
      VisitScheduleMiddelware.showOne(dispatch, params);
    };
  }
  static showOne(dispatch, params) {
    axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
      },
      url: url + '/' + params,
      responseType: 'json'
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(VisitScheduleActions.view(response.data.result));
        }
      })
      .catch((error) => {
        VisitScheduleMiddelware.alertHendler(dispatch, error)
      });
  }


  static resetList() {
    return (dispatch) => {
      dispatch(VisitScheduleActions.resetList());
    };
  }
  static list(params) {
    return (dispatch) => {
      dispatch(VisitScheduleActions.process());
      VisitScheduleMiddelware.showlist(dispatch, params);
    };
  }
  static showlist(dispatch, params) {
    axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
      },
      url: url,
      responseType: 'json',
      params: params
    })
      .then((response) => {

        if (response && response.status === 200 && response.data) {
          dispatch(VisitScheduleActions.list(response.data.result));
        }
      })
      .catch((error) => {
        VisitScheduleMiddelware.alertHendler(dispatch, error)
      });
  }
  

  static closeModal(){
    return (dispatch) => {
      dispatch(VisitScheduleActions.closeModal());
      
    };
  }

  static delete(data){
    return (dispatch) => {
      VisitScheduleMiddelware.deleteData(dispatch,data);
    };
  }

  static deleteData(dispatch,params){
    axios({
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
      },
      url:url+'/'+params,
      responseType: 'json'
    })
    .then((response) => {
      if (response && response.status === 200 && response.data) {
        dispatch(VisitScheduleActions.delete());
        dispatch(VisitScheduleActions.fetchSchedule(response.data.result));
        VisitScheduleMiddelware.alertHendler(dispatch, response, true, 'Delete Data Successfully', 'success')
      }
    })
    .catch((error) => {
      VisitScheduleMiddelware.alertHendler(dispatch,error)
    });
}


  static view(data){
    return (dispatch) => {
      dispatch(VisitScheduleActions.process());
      VisitScheduleMiddelware.getOne(dispatch,data);
    };
  }

  static getOne(dispatch,params){
    axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
      },
      url:url+'/'+params,
      responseType: 'json'
    })
    .then((response) => {
      
      if (response && response.status === 200 && response.data) {
        let result=response.data.result
       
        dispatch(VisitScheduleActions.view(result));
      }
    })
    .catch((error) => {
      VisitScheduleMiddelware.alertHendler(dispatch,error)
    });
}

  static create(data){
    return (dispatch) => {
      dispatch(VisitScheduleActions.create());
      VisitScheduleMiddelware.formHelper(dispatch,data);
    };
  }

  static create(data){
    return (dispatch) => {
      dispatch(VisitScheduleActions.create());
      VisitScheduleMiddelware.formHelper(dispatch,data);
    };
  }

  static change(data){
    return (dispatch) => {
      dispatch(VisitScheduleActions.change());
      VisitScheduleMiddelware.formHelperChange(dispatch,data);
    };
  }

  static formHelper(dispatch,params){
    axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
      },
      url:process.env.REST_URL+'helper/get-helper-visit-schedule-form' ,
      responseType: 'json',
      params:params
    })
    .then((response) => {
      
      if (response && response.status === 200 && response.data) {
        let result=response.data.result
        let data={
            ...params,
            ...result
        }
        dispatch(VisitScheduleActions.formHelper(data));
      }else{
        dispatch(VisitScheduleActions.formHelper(params));
      }
    })
    .catch((error) => {
      VisitScheduleMiddelware.alertHendler(dispatch,error)
    });
}

static formHelperChange(dispatch,params){
  axios({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
    },
    url:process.env.REST_URL+'helper/get-helper-cashbank-book' ,
    responseType: 'json',
    params:params
  })
  .then((response) => {
    
    if (response && response.status === 200 && response.data) {
      let result=response.data.result
      let data={
          ...params,
          ...result
      }
      dispatch(VisitScheduleActions.formHelperChange(data));
    }else{
      dispatch(VisitScheduleActions.formHelperChange(params));
    }
  })
  .catch((error) => {
    VisitScheduleMiddelware.alertHendler(dispatch,error)
  });
}

  static resetList(){
    return (dispatch) => {
        dispatch(VisitScheduleActions.resetList());
      };
  }

  static getHelper(params=null){
    return (dispatch) => {
      VisitScheduleMiddelware.showHelper(dispatch,params);
      };
  }
  static showHelper(dispatch,params){
      axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-visit-schedule' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(VisitScheduleActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        VisitScheduleMiddelware.alertHendler(dispatch,error)
      });
  }

  static show(data){
    return (dispatch) => {
      dispatch(VisitScheduleActions.process());
      VisitScheduleMiddelware.showSchedule(dispatch,data)
    };
  }

  static showSchedule(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
        },
        url:url+'/show' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(VisitScheduleActions.fetchSchedule(response.data.result));
        }
      })
      .catch((error) => {
        VisitScheduleMiddelware.alertHendler(dispatch,error)
      });
  }


  static beforeSaveNew(data){
    return (dispatch) => {
      dispatch(VisitScheduleActions.submit());
      VisitScheduleMiddelware.saveNew(dispatch,data)
    };
  }

  static saveNew(dispatch,data){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
        },
        url:url ,
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(VisitScheduleActions.fetchSchedule(response.data.result));
        }
      })
      .catch((error) => {
        VisitScheduleMiddelware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch,id,data,search){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
        },
        url:url+'/'+id ,
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(VisitScheduleActions.afterUpdate(),VisitScheduleMiddelware.showlist(dispatch, search));
          VisitScheduleMiddelware.alertHendler(dispatch, response, true, 'Update Schedule Successfully', 'success')
        }
      })
      .catch((error) => {
        VisitScheduleMiddelware.alertHendler(dispatch,error)
      });
  }

  static saveChange(dispatch,data,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${VisitScheduleMiddelware.getToken()}`
        },
        url:url+'/change-sales' ,
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(VisitScheduleActions.afterChange(),VisitScheduleMiddelware.showlist(dispatch, search));
          VisitScheduleMiddelware.alertHendler(dispatch, response, true, 'Change Sales Schedule Successfully', 'success')
        }
      })
      .catch((error) => {
        VisitScheduleMiddelware.alertHendler(dispatch,error)
      });
  }


  static alertHendler(dispatch, result, isSwal = false, extraMessage = '', type = 'error') {
    if (type == 'error') {
      if (result.response) {
        const status = result.response.status
        switch (status) {

          case 500:
            console.log('error 500')
            if (isSwal) {
              const data = result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title: 'Delete Error',
                html: data.error,
                icon: 'error',
                showConfirmButton: true,
              })
            } else {
              const data = result.response.data
              dispatch(VisitScheduleActions.error(data.error));
            }
            break;
          case 403:
            console.log('Error 403');
            break;
          case 404:
            console.log('Error 404');
            break;
          case 401:
            console.log('error 401')
            const data = result.response.data
            MySwal.fire({
              title: 'Login Invalid',
              html: data.error,
              icon: 'error',
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>
              }
            })
            break;
        }
      } else if (result.request) {
        console.log('error request')
        MySwal.fire({
          title: 'Internal Server Error',
          html: 'Please info your Developer to fix this',
          icon: 'error',
          showConfirmButton: true,
        })
        dispatch(VisitScheduleActions.error('Internal Server Error'));
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
        dispatch(VisitScheduleActions.error('Internal Server Error'));
      }
    } else {
      MySwal.fire({
        title: 'Success',
        html: extraMessage,
        icon: 'success',
        showConfirmButton: true,
      })
    }
  }
}
